import React from 'react';
import { Icon } from './Icon.tsx';

const NativeButton = 'button';

export interface SegmentedControlOption {
    value: string;
    label: string;
    icon?: string;
}

interface SegmentedControlProps {
    options: SegmentedControlOption[];
    value: string;
    onChange: (value: string) => void;
    ariaLabel?: string;
    className?: string;
    size?: 'sm' | 'md' | 'lg';
}

const sizeClasses = {
    sm: 'px-2 py-1 text-xs',
    md: 'px-3 py-1 text-sm',
    lg: 'px-4 py-2 text-base'
};

/**
 * SegmentedControl - iOS-style segmented control for mode/view switching
 * 
 * @example
 * <SegmentedControl
 *   options={[
 *     { value: 'blocking', label: 'Blocking', icon: 'gesture' },
 *     { value: 'choreography', label: 'Choreography', icon: 'art_track' }
 *   ]}
 *   value={mode}
 *   onChange={setMode}
 * />
 */
export const SegmentedControl: React.FC<SegmentedControlProps> = ({
    options,
    value,
    onChange,
    ariaLabel,
    className = '',
    size = 'md'
}) => (
        <fieldset
            className={`flex min-w-0 rounded-lg border-0 bg-gray-100 p-1 dark:bg-black/20 ${className}`}
            aria-label={ariaLabel}
        >
            {options.map((option) => (
                <NativeButton
                    type="button"
                    key={option.value}
                    aria-pressed={value === option.value}
                    onClick={() => onChange(option.value)}
                    className={`
                        ${sizeClasses[size]} flex items-center gap-1.5 rounded-md font-medium transition-colors ${value === option.value
                            ? 'bg-white text-primary-600 shadow dark:bg-surface-dark dark:text-primary-400'
                            : 'text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-200'
                        }
                    `}
                >
                    {option.icon ? <Icon name={option.icon} size="sm" /> : null}
                    {option.label}
                </NativeButton>
            ))}
        </fieldset>
    );

SegmentedControl.displayName = 'SegmentedControl';













